import { type GenericPolyElement, type PointBezierHandle } from '..';
import { type Point } from '../../../utils/math';

import { initHandlesFromPoints } from './bezierHandles';
import { getBoundsWithBezier } from './bounds';

export const getPolyElementAbsoluteCoordsFromPoints = (
  points: Point[],
  elementX: number,
  elementY: number,
  handles?: PointBezierHandle[],
) => {
  const bezierHandles =
    handles != null && handles.length === points.length
      ? handles
      : initHandlesFromPoints(points);

  const [minX, minY, maxX, maxY] = getBoundsWithBezier(points, bezierHandles);

  const x1 = minX + elementX;
  const y1 = minY + elementY;
  const x2 = maxX + elementX;
  const y2 = maxY + elementY;
  return {
    x1,
    x2,
    y1,
    y2,
    cx: (x1 + x2) / 2,
    cy: (y1 + y2) / 2,
  };
};

export const getPolyElementAbsoluteCoords = (
  element: GenericPolyElement,
): ReturnType<typeof getPolyElementAbsoluteCoordsFromPoints> => {
  return getPolyElementAbsoluteCoordsFromPoints(
    element.points,
    element.x,
    element.y,
    element.bezierHandles,
  );
};
